import React from 'react'
import { css } from '@emotion/css'
import Spinner from 'react-spinkit'
import { theme } from '@contrast-security-inc/design-system-foundations'

export function LegacyGridSpinner({
  dataTestID
}: {
  readonly dataTestID?: string
}) {
  return (
    <div
      data-testid={dataTestID}
      className={css`
        height: 77px;
        display: flex;
        justify-content: center;
        align-items: center;
      `}
    >
      <Spinner
        data-testid="legacy-grid-loading-indicator-spinner"
        name="ball-beat"
        fadeIn="none"
        color={theme.color.teal50}
      />
    </div>
  )
}
